module.exports = __webpack_public_path__ + "img/MobilyActive.5ad93a19.svg";